export class InvoiceSettingModel {
  public companyName: string;
  public address: string;
  public email: string;
  public ibanNumber: string;
  public chamberOfCommerce: string;
  public vatNumber: string;
  public invoicePreFix: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/invoicing-setting/models/invoicing-setting.model.ts